module.exports = __webpack_public_path__ + "img/rr_kabel.dd9c6c33.jpg";